import React from "react";
import ProjectsFinanceDashboard from "../ProjectsFinanceDashboard";

const ProjectsFinanceWidget = () => (
  <div className="widget-content-scroll">
    <ProjectsFinanceDashboard />
  </div>
);

export default ProjectsFinanceWidget;
